// @flow
import { APICore } from './apiCore';
import config from '../../config';

const api = new APICore();

function getAllIntegrationTypes(query) {
    if (typeof query === 'string') {
      return api.get(`${config.INTEGRATION_TYPES_URL}?${query}`);
    }
    return api.get(config.INTEGRATION_TYPES_URL, query);
  }

export {
    getAllIntegrationTypes,
};
